

















































































import { Component, Vue, Prop } from "vue-property-decorator";
//  helpers
import dateHelper from "Utilities/date-helper";
//  components
import { TableRow } from "@/types/widgetNotification";

@Component({})
export default class CriticalTooltip extends Vue {
  @Prop() tableRow!: TableRow;

  get hasNoCriticalIncidents(): boolean {
    if (!this.tableRow) return false;
    return this.tableRow.notificationModuleEnabled && this.tableRow.criticalIncidents.amount === 0 && this.tableRow.activeConditions !== 0;
  }

  formatedDateString(date: string): string | null {
    if (!date) return null;
    return dateHelper.getFormatedDateTimeString(date);
  }
}
